import { render, staticRenderFns } from "./AppFormGroupTelefoonnummer.vue?vue&type=template&id=5fe12324&"
import script from "./AppFormGroupTelefoonnummer.vue?vue&type=script&lang=ts&"
export * from "./AppFormGroupTelefoonnummer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports